import { render } from "./OQC.vue?vue&type=template&id=2c5ba54b&scoped=true"
import script from "./OQC.vue?vue&type=script&lang=js"
export * from "./OQC.vue?vue&type=script&lang=js"

import "./OQC.vue?vue&type=style&index=0&id=2c5ba54b&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5ba54b"]])

export default __exports__